import React, { useEffect, useState } from "react";

import "../asset/finance.css";

import FinanceTable from "../../components/Paiement/Finance/FinanceTable";
import FinanceForm from "../../components/Paiement/Finance/FinanceForm";

import {
    getFinances,
    createFinance,
    updateFinance,
    deleteFinance
} from "../../api/financeService.api";

import {
    getRendezVous
} from "../../api/rendezVousService.api";


const FinancePage = () => {

    // =====================================================
    // STATES
    // =====================================================

    const [finances, setFinances] = useState([]);

    const [rendezVous, setRendezVous] = useState([]);

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");

    const [showForm, setShowForm] = useState(false);

    const [financeSelectionnee, setFinanceSelectionnee] =
        useState(null);


    // =====================================================
    // CHARGER LES FINANCES
    // =====================================================

    const chargerFinances = async () => {

        try {

            setLoading(true);
            setError("");

            const response = await getFinances();

            const data = Array.isArray(response)
                ? response
                : response?.data || [];

            console.log("FINANCES :", data);

            setFinances(data);

        } catch (err) {

            console.error(
                "Erreur chargement finances :",
                err
            );

            setError(
                err?.response?.data?.message ||
                "Erreur lors du chargement des finances."
            );

        } finally {

            setLoading(false);

        }
    };


    // =====================================================
    // CHARGER LES RENDEZ-VOUS
    // =====================================================

    const chargerRendezVous = async () => {

        try {

            const response = await getRendezVous();

            const data = Array.isArray(response)
                ? response
                : response?.data || [];

            console.log("RENDEZ-VOUS :", data);

            setRendezVous(data);

        } catch (err) {

            console.error(
                "Erreur chargement rendez-vous :",
                err
            );

            setError(
                err?.response?.data?.message ||
                "Erreur lors du chargement des rendez-vous."
            );
        }
    };


    // =====================================================
    // CHARGEMENT INITIAL
    // =====================================================

    useEffect(() => {

        chargerFinances();
        chargerRendezVous();

    }, []);


    // =====================================================
    // AJOUTER
    // =====================================================

    const handleAjouter = () => {

        setFinanceSelectionnee(null);

        setError("");

        setShowForm(true);

    };


    // =====================================================
    // MODIFIER
    // =====================================================

    const handleModifier = (finance) => {

        setFinanceSelectionnee(finance);

        setError("");

        setShowForm(true);

    };


    // =====================================================
    // SUPPRIMER
    // =====================================================

    const handleSupprimer = async (id) => {

        const confirmation = window.confirm(
            `Voulez-vous vraiment supprimer la finance #${id} ?`
        );

        if (!confirmation) {
            return;
        }


        try {

            setError("");

            setLoading(true);

            await deleteFinance(id);

            await chargerFinances();

        } catch (err) {

            console.error(
                "Erreur suppression finance :",
                err
            );

            setError(
                err?.response?.data?.message ||
                "Erreur lors de la suppression de la finance."
            );

        } finally {

            setLoading(false);

        }
    };


    // =====================================================
    // ENREGISTRER
    // =====================================================

    const handleSubmit = async (data) => {

        try {

            setError("");

            setLoading(true);


            // -------------------------------------------------
            // MODIFICATION
            // -------------------------------------------------

            if (financeSelectionnee) {

                await updateFinance(
                    financeSelectionnee.id,
                    data
                );

            }


            // -------------------------------------------------
            // CRÉATION
            // -------------------------------------------------

            else {

                await createFinance(data);

            }


            // Fermer le formulaire

            setShowForm(false);

            setFinanceSelectionnee(null);


            // Recharger

            await chargerFinances();

        } catch (err) {

            console.error(
                "Erreur sauvegarde finance :",
                err
            );

            setError(
                err?.response?.data?.message ||
                "Erreur lors de l'enregistrement de la finance."
            );

            throw err;

        } finally {

            setLoading(false);

        }
    };


    // =====================================================
    // ANNULER
    // =====================================================

    const handleAnnuler = () => {

        setShowForm(false);

        setFinanceSelectionnee(null);

        setError("");

    };


    // =====================================================
    // RENDER
    // =====================================================

    return (

        <div className="finance-page">

            {/* =================================================
                HEADER
            ================================================= */}

            <div className="page-header">

                <div>

                    <h1>
                        Finance
                    </h1>

                    <p>
                        Gestion financière des rendez-vous
                    </p>

                </div>


                <div className="page-actions">

                    <button
                        type="button"
                        onClick={chargerFinances}
                        disabled={loading}
                    >

                        {loading
                            ? "Chargement..."
                            : "Actualiser"
                        }

                    </button>


                    {!showForm && (

                        <button
                            type="button"
                            onClick={handleAjouter}
                        >

                            + Nouvelle finance

                        </button>

                    )}

                </div>

            </div>


            {/* =================================================
                ERREUR
            ================================================= */}

            {error && (

                <div className="alert alert-danger">

                    {error}

                </div>

            )}


            {/* =================================================
                FORMULAIRE
            ================================================= */}

            {showForm && (

                <FinanceForm

                    finance={financeSelectionnee}

                    rendezVous={rendezVous}

                    onSubmit={handleSubmit}

                    onCancel={handleAnnuler}

                    loading={loading}

                />

            )}


            {/* =================================================
                TABLEAU
            ================================================= */}

            {!showForm && (

                <FinanceTable

                    finances={finances}

                    loading={loading}

                    onEdit={handleModifier}

                    onDelete={handleSupprimer}

                />

            )}

        </div>

    );
};


export default FinancePage;